// extracted by mini-css-extract-plugin
export var separator = "vertical-spacing-very-small-module--separator---AaIr";